export default "/_next/static/images/0cef034e8f177eda8b94ccfce7bf391f.jpg";